import { useEffect, useState } from "react";
import { getTipoOperacion } from "../pages/operaciones/helpers/api.helper";
import { useToast } from "@chakra-ui/react";

function useTiposOperaciones({ setLoading }) {
  const toast = useToast();
  const [tipoOperaciones, setTipoOperaciones] = useState([]);

  const getTipoOperaciones = async () => {
    setLoading(true);
    try {
      const response = await getTipoOperacion();
      setTipoOperaciones(response);
    } catch (error) {
      console.error("Error fetching tipoOperaciones:", error);
      toast({
        title: "Error",
        description: "No se pudieron cargar los tipos de operación",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTipoOperaciones();
  }, []);

  return { tipoOperaciones };
}

export default useTiposOperaciones;
